import styled from 'styled-components';

export const MainStyled = styled.div`
  .container {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    margin-top: 180px;
    @media (min-width: 310px) {
      margin-top: 160px;
    }
    @media (min-width: 385px) {
      margin-top: 140px;
    }
    @media (min-width: 660px) {
      margin-top: 112px;
    }
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 168px;
      margin-bottom: 153px;
    }
  }
`;

export const TextColumn = styled.div`
  @media (min-width: 992px) {
    max-width: 551px;
    width: 100%;
    margin-top: 52px;
  }
`;

export const Title = styled.div`
  color: var(--black);
  font-family: Rubik;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 56px;
  @media (min-width: 992px) {
    font-size: 64px;
    line-height: 72px;
  }
`;

export const Subtitle = styled.p`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 21px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 32px;
    margin-top: 37px;
    max-width: 455px;
  }
`;

export const ImageColumn = styled.div`
  width: 100%;
  img {
    object-fit: cover;
    width: 100%;
    &:first-of-type {
      display: none;
      @media (min-width: 992px) {
        display: inline;
        height: 431px;
        width: 552px;
      }
    }
    &:last-of-type {
      @media (min-width: 992px) {
        display: none;
      }
    }
  }
`;
